import { render, staticRenderFns } from "./IndicatorChart.vue?vue&type=template&id=2dfb1972&scoped=true"
import script from "./IndicatorChart.vue?vue&type=script&lang=js"
export * from "./IndicatorChart.vue?vue&type=script&lang=js"
import style0 from "./IndicatorChart.vue?vue&type=style&index=0&id=2dfb1972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfb1972",
  null
  
)

export default component.exports